import type { QueryRequestData } from '@ricoh/ria.client.core/plugins/swr/request';

import { createEndpointConfig } from '@ricoh/ria.client.core/plugins/swr/common';
import { createQueryRequest } from '@ricoh/ria.client.core/plugins/swr/request';

import type { CreateLicenseRequestData } from './_request.type';

import createRequestConfig from '../_config';

/** License request config. */
const requestConfig = createRequestConfig('license', (keyBase) => ({
  getLicenseList: createEndpointConfig(`[post] ${keyBase}/licenses/list`, (query: QueryRequestData) => {
    const { headers, params } = createQueryRequest(query, {});

    return {
      method: 'post',
      url: 'licenses/list',
      headers,
      data: params,
    };
  }),

  createLicense: createEndpointConfig(`[post] ${keyBase}/licenses`, (requestData: CreateLicenseRequestData) => ({
    method: 'post',
    url: 'licenses',
    data: requestData,
  })),

  getLicenses: createEndpointConfig(`[get] ${keyBase}/licenses/check-info/:code`, (code: string) => ({
    method: 'get',
    url: `licenses/check-info/${code}`,
  })),

  validateLicenseCode: createEndpointConfig(`[get] ${keyBase}/licenses/validate/:code`, (code: string) => ({
    method: 'get',
    url: `licenses/validate/${code}`,
  })),

  getAllowedFeatures: createEndpointConfig(`[get] ${keyBase}/licenses/tenant/allowed-features`, () => ({
    method: 'get',
    url: `licenses/tenant/allowed-features`,
  })),
}));

export default requestConfig;
